<template>
    <div class="step-counter">
        <p class="caps">ШАГ {{currentStep}}</p>
        <div class="counter">
            <div class="step-indicator" :class="getClass(index + 1)" v-for="(step, index) of numberOfStep - 1"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "step_counter",
        props:{
            currentStep: Number,
            numberOfStep: Number,
        },
        methods:{
            getClass(index){
                if(index === this.currentStep) return "current";
                else if(index < this.currentStep) return "done"
            }
        }
    }
</script>

<style scoped lang="scss">
    .step-counter{
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        p.caps{
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
        }

        .counter{
            display: flex;
            align-items: center;

            .step-indicator{
                height: 2px;
                width: 20px;
                background-color: $bg_line;
                border-radius: 4px;
                &:not(:last-of-type){
                    margin-right: 4px;
                }
                &.current{
                    background-color: $text_gray;
                }
                &.done{
                    background-color: $blue;
                }
            }
        }
        @include mobile{
            margin-bottom: 8px;
        }
    }
</style>